const com10 = {
    length: { min: 16, max: 20 },
    payload: [
        { length: 1, name: "código", type: "bytes", description: "Código de configuración (1 byte).", pad: "00" },
        { length: 1, name: "nope2", type: "bytes", description: "No se usa.", pad: "00" },
        { length: 2, name: "idtime", type: "bytes", description: "Empieza a medir desde idtime (en minutos). idtime = 0000 es medianoche", range: { min: 0, max: 1439 }, pad: "0000" },
        { length: 2, name: "idim", type: "bytes", description: "Minutos entre medidas.", range: { min: 1, max: 1439 }, pad: "0000" },
        { length: 2, name: "nope3", type: "bytes", description: "No se usa.", pad: "0000" },
    ],
};

export default com10;